import { connect } from 'react-redux';
import ErrorView from './ErrorView';

function mapStateToProps(state) {
  return {
    auth: state.users.auth
  }
}

export default connect(mapStateToProps)(ErrorView);



// WEBPACK FOOTER //
// ./src/modules/errors/ErrorContainer.js